import React, { useState } from "react";
import Button from "./Button";
import CenterIcon from "./CenterIcon";
import Container from "./Container";
import FollowUpTableCard from "./FollowUpTableCard";
import { ReactComponent as HeaderDecore } from "../../assets/parent-dashboard-assets/headerDecore.svg";
import { useLanguage } from "../../context/LanguageContext";
const content = {
    ar: {
        noCourses: "لا يوجد كورسات مشترك بها نجلك حاليا لعرض البيانات",
        selectCourse: "أختر الكورس أولا لإظهار كل ما يخص نجلك من إحصائيات ونتائج",
        statisticsTitle: "تفاصيل احصائيات",
        child: "نجلك !",
        showContent: "عرض المحتوى",
        hideContent: "إخفاء المحتوى",
        noContent: "لم يتم نزول المحتوى في هذا الكورس حتى الآن",
    },
    en: {
        noCourses: "Your child is not enrolled in any courses currently.",
        selectCourse: "Select a course first to view statistics and results.",
        statisticsTitle: "Statistics Details",
        child: "Your Child!",
        showContent: "Show Content",
        hideContent: "Hide Content",
        noContent: "No content has been uploaded for this course yet.",
    },
    de: {
        noCourses: "Ihr Kind ist derzeit in keinen Kursen eingeschrieben.",
        selectCourse: "Wählen Sie zuerst einen Kurs aus, um Statistiken und Ergebnisse anzuzeigen.",
        statisticsTitle: "Statistikdetails",
        child: "Ihr Kind!",
        showContent: "Inhalt anzeigen",
        hideContent: "Inhalt ausblenden",
        noContent: "Für diesen Kurs wurde noch kein Inhalt hochgeladen.",
    },
};

const CourseFollowUpSection = ({ course, followUpData }) => {
    const [showWeeks, setShowWeeks] = useState(false);
    const { language } = useLanguage();

    if (followUpData.courses < 1) {
        return (
            <div className="text-center py-10">
                <h2 className="text-2xl font-bold text-cyan-800 dark:text-cyan-100 smooth font-expo">
                    {content[language].noCourses}
                </h2>
            </div>
        );
    } else if (course.length < 1) {
        return (
            <div className="text-center py-10">
                <h2 className="text-2xl font-bold text-cyan-800 dark:text-cyan-100 smooth font-expo">
                    {content[language].selectCourse}
                </h2>
            </div>
        );
    } else {
        return (
            <div className=" bg-[#F8F8F8] border border-black dark:bg-slate-900 smooth flex-center-both flex-col pt-10 shadow-md rounded-xl px-4">
                <div>
                    <div className="  text-center md:text-5xl text-3xl pt-5 pb-10 flex-center-both space-x-3 space-x-reverse">
                        <span className="clr-text-primary font-bold smooth">
                            {content[language].statisticsTitle}
                            <span className="text-cyan-500  font-balabeloo">
                                {" "}
                                {content[language].child}{" "}
                            </span>
                        </span>
                    </div>
                </div>
                <OwnTitle
                    showWeeks={showWeeks}
                    setShowWeeks={setShowWeeks}
                    isToShowWeeks={course.sections.length}
                    title={course.name}
                />

                <Container className="flex-center-both w-full gap-8 flex-col">
                    {course.sections.length > 0 ? (
                        <>
                            {!showWeeks ? (
                                <></>
                            ) : (
                                <>
                                    <div className="flex flex-col gap-2 w-full">
                                        {course.sections.map((section) => (
                                            <FollowUpTableCard key={section.id} section={section} />
                                        ))}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        ""
                    )}
                </Container>
            </div>
        );
    }
};

const OwnTitle = ({ showWeeks, setShowWeeks, title, isToShowWeeks = true }) => {
    const { language } = useLanguage();

    return (
        <>
            <div className="w-full flex flex-col flex-center-both space-y-5">
                <div className="relative h-fit flex-center-both group">
                    <h1 className=" md:font-w-bold clr-text-primary smooth z-10 pb-4 text-center text-2xl sm:text-3xl md:text-3xl ">
                        {title}
                        {/* <span className="font-w-bold">"{weekStatus}"</span> */}
                    </h1>
                    <div className="absolute right-0 w-[130px]">
                        <HeaderDecore className="opacity-70 group-hover:blur-sm  fill-secYellow-700 dark:fill-secYellow-200 smooth" />
                    </div>
                </div>
                <div className="pt-2">
                    {isToShowWeeks ? (
                        <Button
                            className="flex-center-both space-x-2 font-w-bold space-x-reverse border-cyan-500 text-cyan-500 smooth group bg- border underline"
                            onClick={() => setShowWeeks(!showWeeks)}
                        >
                            {!showWeeks ? (
                                <span className="">{content[language].showContent}</span>
                            ) : (
                                <span className="">{content[language].hideContent}</span>
                            )}
                            <CenterIcon
                                className={`transform smooth text-cyan-500 ${
                                    showWeeks ? "pb-1 -rotate-180 " : "pt-0.5 rotate-0"
                                }`}
                                icon="bxs:up-arrow"
                            />
                        </Button>
                    ) : (
                        <div className="font-w-bold bg-third-container border-secondary-container smooth rounded-md border clr-text-primary px-5 py-2">
                            <div>
                                <span className="">{content[language].noContent}</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default CourseFollowUpSection;
